// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Kj9k","backBtn":"styles_backBtn__YDh1r"};